<pathPantalla></pathPantalla>

<!-- Filtros -->
<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- título -->
            <header>
                <h3> {{sistemaService.NombrePantallaActual}} </h3>
            </header>
            <div class="separador"></div>
            <filtros (filtroAplicado)="SetDatos($event)" [filtros]="filtrosDisplay" [urlApi]="uriApi" [verBotonConsultar]="false" #filtrosComponent></filtros>
        </section>
    </div>
</div>

<div class="divisor8"></div>

<div class="row">
    <div class="col-lg-12" style="padding: 0px">
        <section class="widget">
            <!-- tabla -->
            <div>

                <!-- Agregar  -->
                <div>
                    <button class="btn boton botonXS" (click)="Modal()" *ngIf="sistemaService.permisos.agregar">
                        <span class="fa fa-plus"></span>
                        <span> {{'Agregar'}}</span>
                    </button>
                </div>

                <div class="divisor16"></div>

                <!-- datos -->
                <dx-data-grid
                    (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                    id="tabla"
                    [columnAutoWidth]="true"
                    [dataSource]="dataTable"
                    [showColumnHeaders]="true"
                    (onCellPrepared)="onCellPrepared($event)"
                    >
                    <dxo-export [enabled]="true" [fileName]="sistemaService.NombrePantallaActual" *ngIf="sistemaService.permisos.exportar"></dxo-export>

                    <dxo-search-panel
                        [visible]="true"
                        [width]="240"
                        placeholder="{{'Buscar' | translate}}">
                    </dxo-search-panel>

                    <dxo-paging [pageSize]="sistemaService.tablaPaginacion"></dxo-paging>
                    <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                    <dxo-pager
                        [visible]="true"
                        [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                        [displayMode]="sistemaService.tablaPaginacionModo"
                        [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                        [showInfo]="sistemaService.tablaPaginacionInfo"
                        [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                    </dxo-pager>

                    <dxo-row-dragging
                        [allowReordering]="true"
                        [onReorder]="onReorder"
                        [showDragIcons]="true"
                        [onDragStart]="onDragStart"
                        [onDragEnd]="onDragEnd"
                        ></dxo-row-dragging>

                    <dxi-column
                        [allowExporting]="false"
                        caption="Acciones"
                        cellTemplate="cellAcciones"
                        alignment="center">

                    </dxi-column>
                    <dxi-column
                        cellTemplate="cellOrden"
                        dataField="orden"
                        alignment="center"
                        [calculateCellValue]="sistemaService.GetValorOrden"
                        caption="Orden de visualización">
                    </dxi-column>
                    <dxi-column
                        dataField="nombre"
                        caption="Nombre corto">
                    </dxi-column>
                    <dxi-column
                        dataField="descripcion"
                        caption="Descripción"
                        cellTemplate="cellDescripcion"
                        [width]="500">
                    </dxi-column>
                    <dxi-column
                        dataField="color"
                        caption="Color"
                        cellTemplate="cellColor">
                    </dxi-column>
                    <dxi-column
                        dataField="activo"
                        caption="Activo"
                        cellTemplate="cellActivo"
                        [calculateCellValue]="sistemaService.GetValorActivo"
                        alignment="center">
                    </dxi-column>

                    <!-- Orden-->
                    <div *dxTemplate="let cell of 'cellOrden'">
                        {{ cell.data.activo ? cell.data.orden : '-' }}
                </div>
                <!-- Descripcion -->
                <div *dxTemplate="let cell of 'cellDescripcion'">
                    {{ (cell.data.descripcion.length>200)? (cell.data.descripcion | slice:0:200)+'...':(cell.data.descripcion) }}
            </div>
            <!-- Color -->
            <div *dxTemplate="let cell of 'cellColor'">
                <input type="color" disabled  value="{{cell.data.color}}">
            </div>
            <!-- Activo -->
            <div *dxTemplate="let cell of 'cellActivo'" class="iconoActivo">
                <span *ngIf="cell.data.activo" class="fa fa-check-square-o"></span>
                <span *ngIf="!cell.data.activo" class="fa fa-square-o"></span>
            </div>
            <!-- Acciones -->
            <div *dxTemplate="let cell of 'cellAcciones'">
                <a matTooltip="Editar" class="tablaBoton edit" (click)="Editar(cell.data)" *ngIf="sistemaService.permisos.editar">
                    <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
                </a>
                <a matTooltip="Eliminar" class="tablaBoton separado delete" (click)="Eliminar(cell.data)" *ngIf="sistemaService.permisos.eliminar">
                    <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                </a>
            </div>

        </dx-data-grid>

    </div>
</section>
</div>
</div>

<ng-container *ngIf="abierto">
    <div class="backdrop"></div>
    <div class="modalPanelAdmin animated {{animacion}}">

        <div class="contenido">
            <!-- Título -->
            <div class="encabezadoModal">
                <div class="modalTituloSimple">
                    {{(entidad.competenciaid == 0 ? 'Agregar' : 'Editar')}}
                </div>
            </div>
            <div class="modalContenido">
                <!-- datos -->
                <div>
                    <div class="divisor8"></div>
                    <div>
                        <!-- Datos generales -->
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <inputCustom [titulo]="'Nombre corto'" [(ngModel)]="entidad.nombre" [errorActivo]="errorActivo"></inputCustom>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <colorPicker [titulo]="'Color (RGB/Hex)'" [(ngModel)]="entidad.color" [errorActivo]="errorActivo"></colorPicker>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <textareaCustom [titulo]="'Descripción'" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo"></textareaCustom>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                                <checkBoxCustom [titulo]="'Activo'" [alineacion]="1" [(ngModel)]="entidad.activo"></checkBoxCustom>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <!-- footer -->
            <div class="modalFooter">
                <div class="contenidoFooter botonesIzq">
                    <!-- editar -->
                    <div class="botonDerecha">
                        <button class="boton botonSM filledBlanco" (click)="CerrarModal()">
                            {{'Cancelar' | translate}}
                        </button>
                        <div class="divisorH16"></div>
                        <button class="boton botonSM filled" (click)="Guardar()">
                            {{'Guardar' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
